<template>
  <div>
    <!-- PASO 1 -->
    <modal :show.sync="showModalFirstStep" size="lg" :close-on-backdrop="false" :close-on-esc="false">
      <h6 slot="header" class="modal-title">Formulario Garantía - Paso 1  ****</h6>

      <div class="form-row">
        <div class="col-md-12">
          <base-input label="Tipo Documento">
            <!-- <el-select clearable @change="fetchSubcategoriasList" v-model="model.categoria" filterable -->
            <el-select
              clearable
              v-model="model.document"
              filterable
              placeholder="Seleccione Tipo"
              @change="checkDocumentType"
              :disabled="action == 'view' || action == 'edit'"
            >
              <el-option
                v-for="option in selectTypeDocument"
                :key="option"
                :label="option"
                :value="option"
              >
              </el-option>
            </el-select>
          </base-input>
        </div>
      </div>

    <div class="form-row" v-if="displayEndoso">
      <div class="col-md-12">
        <base-input label="Garantía Referencia">
          <el-select
            v-model="model.guarantee_id"
            filterable
            placeholder="Garantía Referencia"
            @change="selectGuranteesData"
            :disabled="action == 'view'"
          >
            <el-option
              v-for="option in selectGurantees"
              :key="option.label"
              :label="option.label"
              :value="option.value"
            >
            </el-option>
          </el-select>
        </base-input>
      </div>
    </div>
    
    <div class="form-row" v-if="displayEndoso">
      <div class="col-md-12">
        <base-input
            label="Endoso"
            placeholder="Ingrese Endoso"
            name="endorsement"
            v-model="model.endorsement"
            :disabled="action == 'view'"
          >
        </base-input>
      </div>
    </div>

      <div class="form-row">
        <div class="col-md-12">
          <base-input label="Ramo">
            <el-select
              v-model="model.topic"
              filterable
              placeholder="Seleccione ramo"
              @change="selectTopicData"
              :disabled="action == 'view'"
            >
              <el-option
                v-for="option in selectTopics"
                :key="option.id"
                :label="option.name"
                :value="option.id"
              >
              </el-option>
            </el-select>
          </base-input>
        </div>
      </div>

      <div class="form-row">
        <div class="col-md-12">
          <base-input :label="'RUT Contratante'" v-model="model.contractor_dni" :disabled="action == 'view'">
            <vue-simple-suggest
              v-model="model.contractor_dni"
              :list="this.participants"
              :placeholder="'66666666-6'"
              :filter-by-query="true"
              display-attribute="dni"
              value-attribute="id"
              ref="contractor_suggest"
              @select="searchParticipant('contractor')"
              :disabled="action == 'view'"
            >
            </vue-simple-suggest>
          </base-input>
        </div>
      </div>

      <div class="form-row">
        <div class="col-md-12">
          <base-input
            label="Contratante"
            placeholder="Ingrese Contratante"
            name="contractor"
            v-model="model.contractor_name"
            :disabled="action == 'view'"
          >
          </base-input>
        </div>
      </div>

      <div class="form-row">
        <div class="col-md-12">
          <base-input :label="'RUT Asegurado'" v-model="model.insured_dni" :disabled="action == 'view'">
            <vue-simple-suggest
              v-model="model.insured_dni"
              :list="this.participants"
              :placeholder="'66666666-6'"
              :filter-by-query="true"
              display-attribute="dni"
              value-attribute="id"
              ref="insured_suggest"
              @select="searchParticipant('insured')"
              :disabled="action == 'view'"
            >
            </vue-simple-suggest>
          </base-input>
        </div>
      </div>

      <div class="form-row">
        <div class="col-md-12">
          <base-input
            label="Asegurado"
            placeholder="Ingrese Asegurado"
            name="insured"
            v-model="model.insured_name"
            :disabled="action == 'view'"
          >
          </base-input>
        </div>
      </div>

      <!-- <div class="form-row" v-if="model.categoria != '' && model.categoria">
        <div class="col-md-12">
          <base-input label="Subcategoría">
            <el-select
              clearable
              v-model="model.subcategoria"
              filterable
              placeholder="Seleccione subcategoría"
            >
              <el-option
                v-for="option in selectSubcategorias"
                :key="option.label"
                :label="option.label"
                :value="option.value"
              >
              </el-option>
            </el-select>
          </base-input>
        </div>
      </div> -->

      <!-- <div class="form-row">
        <div class="col-md-12">
          <base-input
            label="Nombre"
            placeholder="Ingrese un nombre"
            name="nombre"
            v-model="model.name"
          >
          </base-input>
        </div>
      </div> -->
      <template slot="footer">
        <!-- <base-button
          :disabled="
            model.document == '' ||
            !model.document ||
            model.topic == '' ||
            !model.topic ||
            model.contractor_dni == '' ||
            !model.contractor_dni ||
            model.contractor_name == '' ||
            !model.contractor_name ||
            model.insured_dni == '' ||
            !model.insured_dni ||
            model.insured_name == '' ||
            !model.insured_name
          "
          type="primary"
          @click="toSecondStep"
          >Siguiente</base-button
        > -->
        <base-button type="primary" @click="toSecondStep"
          >Siguiente</base-button
        >
        <base-button
          type="link"
          class="ml-auto"
          @click="showModalFirstStep = false"
          >Cancelar</base-button
        >
      </template>
    </modal>
    <!-- PASO 2 -->
    <modal :show.sync="showModalSecondStep" size="lg">
      <h6 slot="header" class="modal-title">Formulario Garantía - Paso 2</h6>

      <div class="form-row">
        <div class="col-md-12" v-if="action != 'view'" >
          <base-input label="Sponsor">
            <el-select
              v-model="model.sponsor"
              filterable
              placeholder="Seleccione sponsor"
              :disabled="action == 'view'"
            >
              <el-option
                v-for="option in selectSponsors"
                :key="option.label"
                :label="option.label"
                :value="option.value"
              >
              </el-option>
            </el-select>
          </base-input>
        </div>
      </div>
      <div class="form-row">
        <div class="col-md-6">
          <base-input label="Compañía">
            <el-select
              v-model="model.company"
              filterable
              placeholder="Seleccione compañia"
              :disabled="action == 'view'"
            >
              <el-option
                v-for="option in selectCompanies"
                :key="option.label"
                :label="option.label"
                :value="option.value"
              >
              </el-option>
            </el-select>
          </base-input>
        </div>
        <div class="col-md-6">
          <base-input
            label="Póliza"
            placeholder="Ingrese Póliza"
            name="policy"
            v-model="model.policy"
            :disabled="action == 'view' || displayEndoso"
          >
          </base-input>
        </div>
      </div>
 
      <div class="form-row">
        <div class="col-md-6">
          <base-input
            v-model="model.issue_date"
            label="Fecha Emision:"
            :name="'issue_date'"
            v-validate="'required'"
            addon-left-icon="ni ni-calendar-grid-58"
            :disabled="action == 'view'"
          >
            <flat-picker
              slot-scope="{ focus, blur }"
              @on-open="focus"
              @on-close="blur"
              :config="config"
              placeholder="Ingrese Fecha Emision XX-XX-XXXX"
              class="form-control datepicker"
              v-model="model.issue_date"
              :disabled="action == 'view'"

            >
            </flat-picker>
          </base-input>
        </div>
        <div class="col-md-6">
          <base-input
            v-model="model.start_date"
            label="Fecha Inicio:"
            :name="'start_date'"
            v-validate="'required'"
            addon-left-icon="ni ni-calendar-grid-58"
            :disabled="action == 'view'"
          >
            <flat-picker
              slot-scope="{ focus, blur }"
              @on-open="focus"
              @on-close="blur"
              :config="config"
              placeholder="Ingrese Fecha Inicio XX-XX-XXXX"
              class="form-control datepicker"
              v-model="model.start_date"
              :disabled="action == 'view'"
            >
            </flat-picker>
          </base-input>
        </div>
      </div>
      <div class="form-row"></div>
      <div class="form-row">
        <div class="col-md-6">
          <base-input
            v-model="model.end_date"
            label="Fecha Termino:"
            :name="'end_date'"
            v-validate="'required'"
            addon-left-icon="ni ni-calendar-grid-58"
            :disabled="action == 'view'"
          >
            <flat-picker
              slot-scope="{ focus, blur }"
              @on-open="focus"
              @on-close="blur"
              :config="config"
              placeholder="Ingrese Fecha Termino XX-XX-XXXX"
              class="form-control datepicker"
              v-model="model.end_date"
              :disabled="action == 'view'"

            >
            </flat-picker>
          </base-input>
        </div>
        <div class="col-md-6">
          <base-input label="Moneda">
            <el-select
              v-model="model.currency"
              filterable
              placeholder="Seleccione moneda"
              :disabled="action == 'view'"
            >
              <el-option
                v-for="option in selectCurrency"
                :key="option.label"
                :label="option.label"
                :value="option.value"
              >
              </el-option>
            </el-select>
          </base-input>
        </div>
      </div>
      <div class="form-row">
        <div class="col-md-6">
          <base-input
            label="Monto Asegurado"
            placeholder="Ingrese Monto Asegurado"
            name="insured_amount"
            v-model="model.insured_amount"
            :disabled="action == 'view'"
          >
          </base-input>
        </div>
        <div class="col-md-6">
          <base-input
            label="Monto Asegurado Actualizado"
            placeholder="Asegurado Actualizado"
            name="insured_amount_updated"
            v-model="model.insured_amount_updated"
            :disabled="action == 'view'"
          >
          </base-input>
        </div>
      </div>
       <div class="form-row">
        <div class="col-md-12">
          <base-input
            label="Prima neta"
            placeholder="Ingrese Prima neta"
            name="premium"
            v-model="model.premium"
            :disabled="action == 'view'"
          >
          </base-input>
        </div>
      </div>
 
      <div class="form-row">
        <div class="col-md-6" v-if="action != 'view'">
          <base-input
            label="Comisión saldo"
            placeholder="Ingrese Comisión saldo"
            name="commission_amount"
            v-model="model.commission_amount"
            :disabled="action == 'view'"
          >
          </base-input>
        </div>
        <div class="col-md-6"  v-if="action != 'view'">
          <base-input
            label="Comision porcentual"
            placeholder="Ingrese Comision porcentual"
            name="commission_percent"
            v-model="model.commission_percent"
            :disabled="action == 'view'"
          >
          </base-input>
        </div>
      </div>

      <div class="form-row">
        <div class="col-md-12">
          <base-input label="Cobertura">
            <el-select
              v-model="model.coverage"
              filterable
              placeholder="Seleccione Cobertura"
              :disabled="action == 'view' || displayEndoso"
            >
              <el-option
                v-for="option in this.coverages"
                :key="option.id"
                :label="option.name"
                :value="option.id"
              >
              </el-option>
            </el-select>
          </base-input>
        </div>
      </div>
      <div class="form-row">
        <div class="col-md-12">
          <base-input :label="'Consultor'" v-model="model.consultant">
            <vue-simple-suggest
              v-model="model.consultant"
              :list="this.consultants"
              :placeholder="''"
              :filter-by-query="true"
              display-attribute="consultant"
              value-attribute="consultant"
              ref="consultant_suggest"
              @select="searchAttributeSugg('consultant')"
              :disabled="action == 'view' || displayEndoso"
            >
            </vue-simple-suggest>
          </base-input>
        </div>
      </div>
      <div class="form-row">
        <div class="col-md-12">
            <base-input label="Glosa">
          <textarea v-model="model.note"
                    class="form-control form-control-alternative edit-event--description textarea-autosize"
                    placeholder="Glosa" :disabled="action == 'view'">
          </textarea>
          <i class="form-group--bar"></i>
        </base-input>
        </div>
      </div>
      
      <div class="form-row">
        <div class="col-md-12">
          <base-input :label="'Archivos'" v-model="model.files">
            <input  type="file" name="headerImg" @change="changeFile" :disabled="loading" v-if="action != 'view'" ref="fileInput"/>
            <span style="display: block;margin-top: 10px;" v-if="!model.files || !model.files.length">Sin archivos</span>
            <ul style="margin-top: 20px;">
              <li v-for="file in model.files" :key="file.url">
                <a :href="file.url" target="_blank">{{ file.filename }}</a>
                
                <base-button
                  v-if="action != 'view'"
                  style="margin-left: 10px;"
                  @click="removeFile(file)"
                  class="edit"
                  type="warning"
                  size="sm"
                  icon
                >
                  <i class="text-white ni ni-fat-remove"></i>
                </base-button>
              </li>
            </ul>
          </base-input>
        </div>
      </div>

      


 
      <template slot="footer">
        <base-button :disabled="thirdStepReady" type="primary" @click="sendForm" v-if="action == 'create'"
          >Crear Garantía</base-button
        >
        <base-button :disabled="thirdStepReady || loading" type="primary" @click="updateForm" v-if="action == 'edit'"
          >Actualizar Garantía</base-button
        >
         <base-button
          type="link"
          @click="toFirstStep"
          >Volver</base-button
        >
        <base-button type="link" class="ml-auto" @click="showModalSecondStep = false">Cancelar</base-button>
      </template>
    </modal>
    <!--
    PASO 3
  -->
   
  </div>
</template>
<script>
import { Select, Option } from "element-ui";
import BaseTable from "@/components/BaseTable";
import flatPicker from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";
import HtmlEditor from "@/components/Inputs/HtmlEditor";
const FormulaParser = require("hot-formula-parser").Parser;

import Autocomplete from "vuejs-auto-complete";

import VueSimpleSuggest from "vue-simple-suggest";
import "vue-simple-suggest/dist/styles.css"; // Using a css-loader
const Spanish = require("flatpickr/dist/l10n/es.js").default.es;

var parser;

export default {
  components: {
    VueSimpleSuggest,
    BaseTable,
    [Select.name]: Select,
    [Option.name]: Option,
    flatPicker,
    HtmlEditor,
  },
  data() {
    return {
      validated: false,
      selectCompanies: [],
      selectSponsors: [],
      participants: [],
      selectTopics: [
        { label: "Garantía", value: "Garantía" },
        { label: "Garantía Venta en verde", value: "Garantía Venta en verde" },
        { label: "Caución", value: "Caución" },
      ],
      selectTypeDocument: [
        "EMISION DE POLIZA",
        "ENDOSO DE POLIZA",
        "ANULACION DE POLIZA",
      ], // Este debe ser un arreglo de objetos asi: { label: ...(es lo que se ve), value: ...}
      config: { dateFormat: "d-m-Y", allowInput: true },
      selectCurrency: [],

      coverages: [
        { label: "Garantía de venta en verde", value: " Garantía de venta en verde"},
        { label: "Fiel cumplimiento de contratos publicos", value: "Fiel cumplimiento de contratos publicos"},
        { label: "Garantía Venta en Verde", value: "Garantía Venta en Verde"},
        { label: "Correcta inversión de anticipos", value: "Correcta inversión de anticipos"},
        { label: "Fiel cumplimiento de contrato", value: "Fiel cumplimiento de contrato"},
        { label: "Correcta ejecución de contrato", value: "Correcta ejecución de contrato"},
        { label: "Promesa de compraventa", value: "Promesa de compraventa"},
        { label: "Fiel cumplimiento", value: "Fiel cumplimiento"},
        { label: "Anticipo", value: "Anticipo"},
        { label: "Gtia.correc.inv.antic.pri.0148", value: "Gtia.correc.inv.antic.pri.0148"},
      ],

      consultants: [
        { label: "Guillermo Court", value: " Guillermo Court"},
        { label: "Mauricio Ruiz", value: "Mauricio Ruiz"},
        { label: "Paula Sepulveda", value: "Paula Sepulveda"},
      ],

      selectGurantees: [],
      selectGuranteesRaw: [],
      displayEndoso: false,

      action: "create",
      selectGuranteesById : [],
      model: {
        document: "",
        topic: "",
        contractor_dni: "",
        contractor_name: "ssss",
        insured_dni: "",
        insured_name: "",
        company: "",
        sponsor: "",
        policy: "",
        issue_date: "",
        start_date: "",
        end_date: "",
        currency: undefined,
        insured_amount: "",
        insured_amount_updated: "",
        premium: "",
        commission_amount: 0,
        commission_percent: 0,
        coverage: "",
        consultant: "",
        guarantee_id: 0,
        id_g: 0,
        endorsement: "",
        files: [],


        // subcategoria: "",

        // name: "",
        // sign_required: false,
        // vigencia_desde: "",
        // vigencia_hasta: "",
        // campos_enum: [],
        // campos_variable: [],
        // campos_range: [],
        // payment_required: false,
        // materia: undefined,
        
        // tipo_conversion: undefined,
        // valor_conversion: undefined,
        // consideraciones: "",
        // condiciones: "",
        // limite_siniestros: 0,
        // duracion: 1,
        // unidad_duracion: "dias",
        // cubierto: 0.0,
        // file_url: "",
      },
      showModalFirstStep: false,
      showModalSecondStep: false,
      // showModalThirdStep: false,

      selectSubcategorias: [],
      
      searattrsData: [],
      letras: [
        "x",
        "y",
        "z",
        "a",
        "b",
        "c",
        "d",
        "e",
        "f",
        "g",
        "h",
        "i",
        "j",
        "k",
        "l",
        "m",
        "n",
        "o",
        "p",
        "q",
        "r",
        "s",
        "t",
        "u",
        "v",
        "w",
      ],
      formula: "",
      campos_formulas: [],
      campos_enum: [],
      campos_variable: [],
      campos_range: [],

      // selectMaterias: [],
      selectMonedas: [],
      selectTiposConversion: [
        { label: "Default (Fecha actual)", value: "current" },
        { label: "Dia específico", value: "xday" },
        { label: "Último cierre mensual", value: "endlastmonth" },
        { label: "X dias atrás", value: "daysbefore" },
        { label: "X semanas atrás", value: "weeksbefore" },
        { label: "X meses atrás", value: "monthsbefore" },
        { label: "Valor Fijo", value: "fixedvalue" },
      ],
      selectUnidades: [
        { label: "Días", value: "dias" },
        { label: "Meses", value: "meses" },
        { label: "Años", value: "años" },
      ],
      parser: undefined,
      loading: false,
    };
  },
  methods: {
    // async firstFormSubmit() {
    //   try {
    //     return await this.$validator.validateAll();
    //     //throw new Error('hno ke wea esta wea');
    //   } catch {
    //     console.log("Oh, tengo ke caputar algo");
    //     return false;
    //   } finally {
    //     this.validated = true;
    //   }
    // },
    getError(name) {
      return this.errors.first(name);
    },
    isValid(name) {
      return this.validated && !this.errors.has(name);
    },
    //   fetchCategoriasList(){
    //     var vm = this;
    //     this.axios({
    //         method: 'GET',
    //         url: 'api/test_list_categories_from_create_plan'
    //     }).then(response => {
    //         vm.selectTypeDocument = response.data;

    //     }).catch( error => {
    //         console.log(error);
    //     })
    //     ;
    //   },

    fetchParticipantsList() {
      this.participants = [];
      var vm = this;
      this.axios({
        method: "GET",
        url: "api/participants",
      })
        .then((response) => {
          vm.participants = response.data.data;
          console.log(vm.participants);
        })
        .catch((error) => {
          console.log(error);
        });
    },
    searchParticipant(participant) {
      var vm = this;

      if (participant == "contractor") {
        console.log(vm.$refs.contractor_suggest.selected.dni);
        vm.model.contractor_dni = vm.$refs.contractor_suggest.selected.dni;
        vm.model.contractor_name = vm.participants.find(
          (d) => d.dni === vm.$refs.contractor_suggest.selected.dni
        ).name;
      } else if (participant == "insured") {
        console.log(vm.$refs.insured_suggest.selected.dni);
        vm.model.insured_dni = vm.$refs.insured_suggest.selected.dni;
        vm.model.insured_name = vm.participants.find(
          (d) => d.dni === vm.$refs.insured_suggest.selected.dni
        ).name;
      }

      console.log(vm.model.insured_name);
    },
    fetchCurrencyList()
      {
        var vm = this;
        this.axios({
          url: 'api/get_currencies_list_from_create_plan',
          method: 'GET'
        }).then( response => {
          vm.selectCurrency = response.data;
          console.log(vm.selectCurrency);
        }).catch( error => {
          console.log(error);
        })
        ;
      },

    fetchCoveragesList(topic_id) {
      var vm = this;
      vm.coverages = [];
      vm.model.coverage = "";
      this.axios({
        method: "GET",
        url: "api/guarantees/coverages?topic_id="+topic_id,
      })
        .then((response) => {
          vm.coverages = response.data.data;
          console.log(vm.coverages);
        })
        .catch((error) => {
          console.log(error);
        });
    },
    fetchConsultantsList() {
      this.consultants = [];
      var vm = this;
      this.axios({
        method: "GET",
        url: "api/guarantees/consultants",
      })
        .then((response) => {
          vm.consultants = response.data.data;
          console.log(vm.consultants);
        })
        .catch((error) => {
          console.log(error);
        });
    },
    fetchTopicsList() {
      this.selectTopics = [];
      var vm = this;
      this.axios({
        method: "GET",
        url: "api/guarantees/topics",
      })
        .then((response) => {
          vm.selectTopics = response.data.data;
          console.log(vm.selectTopics);
        })
        .catch((error) => {
          console.log(error);
        });
    },

    
    searchAttributeSugg(attr) {
      var vm = this;

      if (attr == "coverage") {
        console.log(vm.$refs.coverage_suggest.selected.coverage);
        vm.model.coverage = vm.$refs.coverage_suggest.selected.coverage;
      }
      if (attr == "consultant") {
        console.log(vm.$refs.consultant_suggest.selected.consultant);
        vm.model.consultant = vm.$refs.consultant_suggest.selected.consultant;
      }
    },
    checkDocumentType(){
      if(this.model.document == 'ENDOSO DE POLIZA'){
        this.fetchGuranteesList();
        this.displayEndoso = true;
      }
      else{
        this.model.guarantee_id = 0;
        this.displayEndoso = false;
      }
    },
    fetchGuranteesList() {
      this.selectGurantees = [];
      this.selectGuranteesRaw = [];
      var vm = this;
      this.axios({
        method: "GET",
        url: "api/guarantees",
        params: {
          document: 'guranatees',
          updated: '1',
        },
      })
        .then((response) => {
          console.log(response.data.data);
          vm.selectGuranteesRaw = response.data.data;
          response.data.data.forEach( item => {
            vm.selectGurantees.push({ value: item.id, label: item.id+' - '+item.policy+' - '+item.company_name});
          } );
  
        })
        .catch((error) => {
          console.log(error);
        });
    },

    // fetchSubcategoriasList() {
    //   this.model.subcategoria = undefined;
    //   var vm = this;
    //   this.axios({
    //     method: "GET",
    //     url:
    //       "api/test_list_subcategories_from_create_plan?categoria=" +
    //       this.model.categoria,
    //   })
    //     .then((response) => {
    //       //if( response.data.length == 0 ) vm.model.subcategoria = undefined;

    //       vm.selectSubcategorias = response.data;
    //       console.log(vm.selectSubcategorias);
    //     })
    //     .catch((error) => {
    //       console.log(error);
    //     });
    // },
    fetchCompaniesList() {
      this.model.company = undefined;
      var vm = this;
      this.axios({
        method: "GET",
        url: "api/test_list_companies_from_create_plan",
      })
        .then((response) => {
          vm.selectCompanies = response.data;
        })
        .catch((error) => {
          console.log(error);
        });
    },
    fetchSponsorsList() {
      this.model.sponsor = undefined;
      var vm = this;
      this.axios({
        method: "GET",
        url: "api/test_list_sponsors_from_create_plan",
      })
        .then((response) => {
          vm.selectSponsors = response.data;
        })
        .catch((error) => {
          console.log(error);
        });
    },
    selectGuranteesData(alldata = false){
      var vm = this;


        console.log(vm.model.guarantee_id);
        console.log(vm.selectGuranteesRaw);

        vm.model.topic = vm.selectGuranteesRaw.find(
          (d) => d.id === vm.model.guarantee_id
        ).gurantee_topic_id;

        vm.model.contractor_dni = vm.selectGuranteesRaw.find(
          (d) => d.id === vm.model.guarantee_id
        ).contractor_dni;

        vm.model.contractor_name = vm.selectGuranteesRaw.find(
          (d) => d.id === vm.model.guarantee_id
        ).contractor_name;

        vm.model.insured_dni = vm.selectGuranteesRaw.find(
          (d) => d.id === vm.model.guarantee_id
        ).insured_dni;

        vm.model.insured_name = vm.selectGuranteesRaw.find(
          (d) => d.id === vm.model.guarantee_id
        ).insured_name;

        vm.model.policy = vm.selectGuranteesRaw.find(
          (d) => d.id === vm.model.guarantee_id
        ).policy;

        vm.model.endorsement = vm.selectGuranteesRaw.find(
          (d) => d.id === vm.model.guarantee_id
        ).endorsement;

        vm.model.issue_date = vm.selectGuranteesRaw.find(
          (d) => d.id === vm.model.guarantee_id
        ).issue_date;  
        vm.model.issue_date = this.$moment(this.model.issue_date, "YYYY-MM-DD").format('DD-MM-YYYY');

        vm.model.start_date = vm.selectGuranteesRaw.find(
          (d) => d.id === vm.model.guarantee_id
        ).start_date;
        vm.model.start_date = this.$moment(this.model.start_date, "YYYY-MM-DD").format('DD-MM-YYYY');

        vm.model.end_date = vm.selectGuranteesRaw.find(
          (d) => d.id === vm.model.guarantee_id
        ).end_date;
        vm.model.end_date = this.$moment(this.model.end_date, "YYYY-MM-DD").format('DD-MM-YYYY');

        vm.model.currency = vm.selectGuranteesRaw.find(
          (d) => d.id === vm.model.guarantee_id
        ).currency_id;

        vm.model.insured_amount = vm.selectGuranteesRaw.find(
          (d) => d.id === vm.model.guarantee_id
        ).insured_amount;

        vm.model.insured_amount_updated = vm.selectGuranteesRaw.find(
          (d) => d.id === vm.model.guarantee_id
        ).insured_amount_updated;

        vm.model.premium = vm.selectGuranteesRaw.find(
          (d) => d.id === vm.model.guarantee_id
        ).premium;

        vm.model.commission_amount = vm.selectGuranteesRaw.find(
          (d) => d.id === vm.model.guarantee_id
        ).commission_amount;

         vm.model.commission_percent = vm.selectGuranteesRaw.find(
          (d) => d.id === vm.model.guarantee_id
        ).commission_percent;

         vm.model.coverage = vm.selectGuranteesRaw.find(
          (d) => d.id === vm.model.guarantee_id
        ).gurantee_coverage_id;

         vm.model.consultant = vm.selectGuranteesRaw.find(
          (d) => d.id === vm.model.guarantee_id
        ).consultant;

         vm.model.note = vm.selectGuranteesRaw.find(
          (d) => d.id === vm.model.guarantee_id
        ).note;

        vm.model.company = vm.selectGuranteesRaw.find(
          (d) => d.id === vm.model.guarantee_id
        ).company_id;

        vm.model.sponsor = vm.selectGuranteesRaw.find(
          (d) => d.id === vm.model.guarantee_id
        ).sponsor_id;

    },
    selectTopicData(){
        var vm = this;
        console.log(vm.model.topic);
        vm.fetchCoveragesList(vm.model.topic);
    },
    getGuranteesData(){
      var vm = this;
      // this.selectGurantees = [];
      this.selectGuranteesById = [];
      var vm = this;
      this.axios({
        method: "GET",
        url: "api/guarantees/"+vm.model.id_g,
      })
      .then((response) => {
        
        vm.selectGuranteesById = response.data;
        console.log('vm.selectGuranteesById');
        console.log(vm.selectGuranteesById);

        vm.model.guarantee_id = vm.selectGuranteesById.guarantee_id;
        vm.model.document = vm.selectGuranteesById.document;
        vm.model.topic = vm.selectGuranteesById.gurantee_topic_id;
        vm.model.contractor_dni = vm.selectGuranteesById.contractor_dni;
        vm.model.contractor_name = vm.selectGuranteesById.contractor_name;
        vm.model.insured_dni = vm.selectGuranteesById.insured_dni;
        vm.model.insured_name = vm.selectGuranteesById.insured_name;
        vm.model.policy = vm.selectGuranteesById.policy;
        
        vm.model.end_date = vm.$moment(vm.selectGuranteesById.end_date, "YYYY-MM-DD").format('DD-MM-YYYY');
        vm.model.issue_date  = vm.$moment(vm.selectGuranteesById.issue_date, "YYYY-MM-DD").format('DD-MM-YYYY');
        vm.model.start_date = vm.$moment(vm.selectGuranteesById.start_date, "YYYY-MM-DD").format('DD-MM-YYYY');

        
        vm.model.endorsement = vm.selectGuranteesById.endorsement;
        vm.model.currency = vm.selectGuranteesById.currency_id;
        vm.model.insured_amount = vm.selectGuranteesById.insured_amount;
        vm.model.insured_amount_updated = vm.selectGuranteesById.insured_amount_updated;
        vm.model.premium = vm.selectGuranteesById.premium;
        vm.model.commission_amount = vm.selectGuranteesById.commission_amount;
        vm.model.commission_percent = vm.selectGuranteesById.commission_percent;
        vm.model.coverage = vm.selectGuranteesById.gurantee_coverage_id;
        vm.model.consultant = vm.selectGuranteesById.consultant;
        vm.model.note = vm.selectGuranteesById.note;
        vm.model.company = vm.selectGuranteesById.company_id;
        vm.model.sponsor = vm.selectGuranteesById.sponsor_id;
        if (vm.selectGuranteesById.files != null && (JSON.parse(vm.selectGuranteesById.files)).length > 0) {
          vm.model.files = JSON.parse(vm.selectGuranteesById.files);
        }
        else{
          vm.model.files = [];
        }
        
        console.log(JSON.parse(vm.selectGuranteesById.files));
        
        vm.checkDocumentType();


        
      })
      .catch((error) => {
        console.log(error);
      });
    },


    // fetchSearchablesdAttributesData() {
    //   var vm = this;
    //   this.axios({
    //     url: "api/get_searattrs_from_create_plan",
    //     method: "POST",
    //     data: {
    //       subcategory: vm.model.subcategoria,
    //     },
    //   })
    //     .then((response) => {
    //       vm.parser = new FormulaParser();
    //       vm.searattrsData = response.data;

    //       vm.campos_formulas = vm.searattrsData.filter(
    //         (elem) =>
    //           elem.tipo_campo == "VARIABLE" ||
    //           (elem.tipo_campo == "RANGE" &&
    //             (elem.tipo_dato == "float" || elem.tipo_dato == "int"))
    //       );
    //       vm.campos_enum = vm.searattrsData.filter(
    //         (elem) => elem.tipo_campo == "ENUM"
    //       );
    //       vm.model.campos_enum = [];
    //       vm.campos_enum.forEach((elem) => {
    //         vm.model.campos_enum.push(undefined);
    //       });
    //       vm.campos_range = vm.searattrsData.filter(
    //         (elem) => elem.tipo_campo == "RANGE"
    //       );
    //       vm.model.campos_range = [];
    //       vm.campos_range.forEach((elem) => {
    //         vm.model.campos_range.push({ desde: undefined, hasta: undefined });
    //       });
    //       vm.campos_variable = vm.searattrsData.filter(
    //         (elem) => elem.tipo_campo == "VARIABLE"
    //       );
    //       vm.model.campos_variable = [];
    //       vm.campos_formulas.forEach((elem, i) => {
    //         vm.model.campos_variable.push({ id: elem.id, letra: vm.letras[i] });
    //         vm.parser.setVariable(vm.letras[i], 1);
    //         console.log("vm.parser.setVariable", vm.letras[i], 1);
    //       });
    //     })
    //     .catch((error) => {});
    // },
    // fetchMateriasList() {
    //   var vm = this;
    //   this.axios({
    //     url: "api/get_materias_list_from_create_plan",
    //     method: "GET",
    //   })
    //     .then((response) => {
    //       vm.selectMaterias = response.data;
    //     })
    //     .catch((error) => {
    //       console.log(error);
    //     });
    // },
    // fetchMonedasList() {
    //   var vm = this;
    //   this.axios({
    //     url: "api/get_currencies_list_from_create_plan",
    //     method: "GET",
    //   })
    //     .then((response) => {
    //       vm.selectMonedas = response.data;
    //     })
    //     .catch((error) => {
    //       console.log(error);
    //     });
    // },
    sendForm() {
      var vm = this;
      // this.firstFormSubmit()
        // .then((response) => {
          // console.log("retorno promesa de validacion", response);

          // if (response) {
            console.log('aaaaa');
            console.log(this.model.files);

            vm.axios({
              method: "POST",
              url: "api/guarantees",
              data: {

                document: this.model.document,
                topic: this.model.topic,
                contractor_dni: this.model.contractor_dni,
                contractor_name: this.model.contractor_name,
                insured_dni: this.model.insured_dni,
                insured_name: this.model.insured_name,
                policy: this.model.policy,
                endorsement: this.model.endorsement,
                issue_date: this.$moment(this.model.issue_date, "DD-MM-YYYY").format('YYYY-MM-DD'),
                start_date: this.$moment(this.model.start_date, "DD-MM-YYYY").format('YYYY-MM-DD'),
                end_date: this.$moment(this.model.end_date, "DD-MM-YYYY").format('YYYY-MM-DD'),
                currency: this.model.currency,
                insured_amount: this.model.insured_amount,
                insured_amount_updated: this.model.insured_amount_updated,
                premium: this.model.premium,
                commission_amount: this.model.commission_amount,
                commission_percent: this.model.commission_percent,
                coverage: this.model.coverage,
                consultant: this.model.consultant,
                note: this.model.note,
                company: this.model.company,
                sponsor: this.model.sponsor,
                guarantee_id: this.model.guarantee_id,
                files_uploades:JSON.stringify(this.model.files)




                // categoria: this.model.categoria,
                // subcategoria: this.model.subcategoria,
                // company: this.model.company,
                // sponsor: this.model.sponsor,
                // nombre: this.model.name,
                // sign_required: this.model.sign_required,
                // //vigencia_desde: this.$moment(this.model.vigencia_desde, "DD-MM-YYYY").format('YYYY-MM-DD'),
                // //vigencia_hasta: this.$moment(this.model.vigencia_hasta, "DD-MM-YYYY").format('YYYY-MM-DD'),
                // campos_enum: this.model.campos_enum,
                // formula: this.formula,
                // campos_range: this.model.campos_range,
                // payment_required: this.model.payment_required,
                // materia: this.model.materia,
                // moneda: this.model.moneda,
                // tipo_conversion:
                //   this.model.tipo_conversion == "" ||
                //   this.model.tipo_conversion == undefined
                //     ? "current"
                //     : this.model.tipo_conversion,
                // valor_conversion: this.model.valor_conversion,
                // consideraciones: this.model.consideraciones,
                // condiciones: this.model.condiciones,
                // campos_variable: this.model.campos_variable,
                // limite_siniestros: this.model.limite_siniestros,
                // duracion: this.model.duracion,
                // unidad_duracion: this.model.unidad_duracion,
                // cubierto: this.model.cubierto,
                // file_url: this.model.file_url,
              },
            })
              .then((response) => {
                vm.$notify({
                  message: "Garantía creada exitosamente!",
                  timeout: 5000,
                  icon: "ni ni-bell-55",
                  type: "success",
                });
                // Cerrar el Modal
                vm.showModalSecondStep = false;
                // Emitir evento para que actualize la tabla de usuarios
                vm.$emit("successSending");
              })
              .catch((error) => {
                if (error.response.status == 422) {
                  Object.entries(error.response.data.errors).forEach((elem) => {
                    vm.$notify({
                      message: elem[1][0],
                      timeout: 5000,
                      icon: "ni ni-bell-55",
                      type: "danger",
                    });
                  });
                } else {
                  console.log(error);
                  vm.$notify({
                    message: "Hubo un error, no se pudo almacenar la garantía",
                    timeout: 5000,
                    icon: "ni ni-bell-55",
                    type: "default",
                  });
                }
              });
          // }
        // })
        // .catch((reason) => {
        //   console.log(reason);
        // });
    },
    updateForm() {
      var vm = this;
            console.log(vm.model.endorsement);
            vm.axios({
              method: "PUT",
              url: "api/guarantees/"+vm.model.id_g,
              data: {
                document: this.model.document,
                topic: this.model.topic,
                contractor_dni: this.model.contractor_dni,
                contractor_name: this.model.contractor_name,
                insured_dni: this.model.insured_dni,
                insured_name: this.model.insured_name,
                policy: this.model.policy,
                endorsement: this.model.endorsement,
                issue_date: this.$moment(this.model.issue_date, "DD-MM-YYYY").format('YYYY-MM-DD'),
                start_date: this.$moment(this.model.start_date, "DD-MM-YYYY").format('YYYY-MM-DD'),
                end_date: this.$moment(this.model.end_date, "DD-MM-YYYY").format('YYYY-MM-DD'),
                currency: this.model.currency,
                insured_amount: this.model.insured_amount,
                insured_amount_updated: this.model.insured_amount_updated,
                premium: this.model.premium,
                commission_amount: this.model.commission_amount,
                commission_percent: this.model.commission_percent,
                coverage: this.model.coverage,
                consultant: this.model.consultant,
                note: this.model.note,
                company: this.model.company,
                sponsor: this.model.sponsor,
                guarantee_id: this.model.guarantee_id,
                files_uploades:JSON.stringify(this.model.files)


 
              },
            })
              .then((response) => {
                vm.$notify({
                  message: "Garantía actualizada exitosamente!",
                  timeout: 5000,
                  icon: "ni ni-bell-55",
                  type: "success",
                });
                // Cerrar el Modal
                vm.showModalSecondStep = false;
                // Emitir evento para que actualize la tabla de usuarios
                vm.$emit("successSending");
              })
              .catch((error) => {
                if (error.response.status == 422) {
                  Object.entries(error.response.data.errors).forEach((elem) => {
                    vm.$notify({
                      message: elem[1][0],
                      timeout: 5000,
                      icon: "ni ni-bell-55",
                      type: "danger",
                    });
                  });
                } else {
                  console.log(error);
                  vm.$notify({
                    message: "Hubo un error, no se pudo almacenar la garantía",
                    timeout: 5000,
                    icon: "ni ni-bell-55",
                    type: "default",
                  });
                }
              });
          
    },
    changeFile(e){
      var vm = this
      
      console.log(e);
      console.log(e.target.files[0].name);
      console.log(e.target.files[0]);

      // const hasName = ['file', 'logo','headerImg'].includes(name)
      // if(hasName && file) this[name] = file
      // else console.log('error')

    if (e.target.files[0] != undefined && e.target.files[0] != null) {
      this.loading = true;
        let formData = new FormData();
          formData.append("fileupload", e.target.files[0]);
          vm.axios({
              url: 'api/guarantees/file',
              data: formData,
              method: 'POST'
          }).then( response => {
          console.log(response);
          // console.log(JSON.stringify(response.data));
          var resultupload = (response.data);
          console.log(resultupload);

          console.log(resultupload);
          console.log('start');
          console.log(vm.model.files);
          vm.model.files.push(resultupload);
          console.log(vm.model.files);            
          console.log('end');
          e.target.files = null;
          this.$refs.fileInput.value = null;
          vm.loading = false;
          }).catch( error => {
              vm.loading = false;
      });
    }
         


    },
    removeFile(file){
      console.log(file);
      console.log(this.model.files);
      this.model.files = this.model.files.filter(item => item !== file);
      console.log(this.model.files);
    },
    toSecondStep() {
    if (this.model.document == 'ENDOSO DE POLIZA' && this.model.guarantee_id == 0) {
      this.$notify({
        message: "Debe seleccionar una Garantía de Referencia para poder continuar",
        timeout: 5000,
        icon: "ni ni-bell-55",
        type: "error",
      });
    }
    else{
       this.showModalFirstStep = false;
      this.showModalSecondStep = true;
      //this.showModalThirdStep = true;
      // this.fetchSearchablesdAttributesData();
       this.fetchCurrencyList();
    }
     


    },
    toFirstStep() {
      this.showModalFirstStep = true;
      this.showModalSecondStep = false;
    },
  },
  mounted() {},
  created() {
    this.$parent.$on("showModalCreatePlan", (action, id) => {
      console.log("showModalCreatePlan", action, id);
      this.action = action;
      this.model.id_g = id;
      this.showModalFirstStep = true;
      // this.fetchCategoriasList();
      this.fetchCompaniesList();
      this.fetchSponsorsList();
      this.fetchCoveragesList();
      this.fetchConsultantsList();
      this.fetchTopicsList();
      this.fetchParticipantsList();

      if ( (this.action == 'edit' || this.action == 'view') && this.model.id_g != 0 ) {
        this.getGuranteesData();
      }
      else if(this.action == 'create'){
        this.model.document = "";
        this.model.topic = "";
        this.model.contractor_dni = "";
        this.model.contractor_name = "";
        this.model.insured_dni = "";
        this.model.insured_name = "";
        this.model.company = "";
        this.model.sponsor = "";
        this.model.policy = "";
        this.model.issue_date = "";
        this.model.start_date = "";
        this.model.end_date = "";
        this.model.currency = undefined;
        this.model.insured_amount = "";
        this.model.insured_amount_updated = "";
        this.model.premium = "";
        this.model.commission_amount = 0;
        this.model.commission_percent = 0;
        this.model.coverage = "";
        this.model.consultant = "";
        this.model.guarantee_id = 0;
        this.model.id_g = 0;
        this.model.endorsement = "";
        this.model.files = [];

        

      }
        
    
    });
    this.parser = new FormulaParser();
  },
  computed: {
    formulaComputed() {
      return this.parser.parse(this.formula).result ? true : false;
    },
    secondStepReady() {
      // var flag = true;
      // this.model.campos_enum.forEach((elem) => {
      //   if (elem == "" || elem == undefined) flag = false;
      // });
      // this.model.campos_range.forEach((elem) => {
      //   console.log("debio haber entrado aqui");
      //   console.log(
      //     parseInt(elem.desde),
      //     parseInt(elem.hasta),
      //     parseInt(elem.hasta) < parseInt(elem.desde)
      //   );
      //   if (
      //     elem.desde == "" ||
      //     elem.desde == undefined ||
      //     !elem.desde ||
      //     parseInt(elem.desde) < 0 ||
      //     elem.hasta == "" ||
      //     elem.hasta == undefined ||
      //     parseInt(elem.hasta) < parseInt(elem.desde) ||
      //     !elem.hasta ||
      //     parseInt(elem.hasta) < 0
      //   ) {
      //     flag = false;
      //   }
      // });
      if (!this.formulaComputed) flag = false;
      if (!this.model.moneda || !this.model.tipo_conversion) flag = false;
      if (!this.model.duracion || !this.model.unidad_duracion) flag = false;
      console.log("resultado secondStepReady", flag);
      return flag;
    },
    thirdStepReady() {
      return false;
    },
  },
};
</script>
<style>
</style>
